import styled from 'styled-components';

export const SlideMobileModalHeaderStyled = styled.div`
    .close {
        float: right;
        padding: 12px;
        margin-top: -8px;
        margin-right: -8px;

        svg {
            fill: var(--color-white-60);
        }
    }
`;

export const SlideMobileModalBoxStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 16px 0;
    background: rgba(129, 146, 228, 0.05);
    border-radius: 16px;
`;

export const SlideMobileModalOrderProtectionStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-top: 1px solid var(--color-base-secondary);
    font-weight: 400;
    font-size: 14px;
    padding: 16px 0;

    .label {
        color: var(--color-white-60);
    }

    .price {
        color: var(--color-white);
    }
`;
